import Library from './Library.vue';
import LibraryList from './LibraryList.vue';
export default {
  Library,
  LibraryList,
};
